import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './routes/home/home.component';
import { LoginComponent } from './routes/login/login.component';
import { AuthenticatedGuard } from './shared/guards/authenticated.guard';
import { TransactionDetailsComponent } from './routes/transaction-details/transaction-details.component';
import { AccountComponent } from './routes/account/account.component';
import { ImprintComponent } from './routes/imprint/imprint.component';
import { RegisterComponent } from './routes/register/register.component';
import { CashcutDetailsComponent } from './routes/cashcut-details/cashcut-details.component';
import { ReportsComponent } from './routes/reports/reports.component';
import { DebugComponent } from './routes/debug/debug.component';
import {EmailMigrationComponent} from "./routes/email-migration/email-migration.component";

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'account',
    component: AccountComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'transaction/:transactionId',
    component: TransactionDetailsComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'cashcut/:cashcutId',
    component: CashcutDetailsComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login/:merchantId',
    component: LoginComponent,
  },
  {
    path: 'register/:merchantId',
    component: RegisterComponent,
  },
  {
    path: 'migrate-email/:merchantId',
    component: EmailMigrationComponent,
  },
  {
    path: 'imprint',
    component: ImprintComponent,
  },
  {
    path: '__debug',
    component: DebugComponent,
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
